import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import useWindowDimensions from "../../utils/useWindowDimensions";

const SingleLineBarChart = ({ data = [], xKey = "category", yKey = "value", chartName = "Series" }) => {
  const [chartData, setChartData] = useState({ series: [], options: {} });
  const { width } = useWindowDimensions();

  useEffect(() => {
    if (data) {
      setChartData({
        series: [
          {
            name: chartName,
            data: data.map((item) => item[yKey] ?? 0),
          },
        ],
        options: {
          chart: {
            type: "bar",
            height: 300,
            toolbar: { show: false },
          },
          colors: ["#06D001"], 
          stroke: {
            show: true,
            width: 2,
            colors: ["transparent"],
          },
          dataLabels: { enabled: false },
          xaxis: {
            categories: data.map((item) => item[xKey] ?? "N/A"),
          },
          legend: {
            position: "top",
            horizontalAlign: "left",
            offsetY: 0,
            offsetX: -35,
          },
          tooltip: {
            y: {
              formatter: (val) => val,
            },
          },
        },
      });
    }
  }, [data, xKey, yKey, chartName]);


  return (
    <div id="chart">
      <ReactApexChart
        options={chartData.options}
        series={chartData.series}
        type="bar"
        height={width > 1700 ? 382 : 282}
      />
    </div>
  );
};

export default SingleLineBarChart;
